<div
  [className]="imgblock?.className"
  [ngStyle]="{
    display: imgblock.display,
    background: imgblock.background,
    'padding-top': imgblock.paddingTop,
    'padding-bottom': imgblock.paddingBottom,
    'text-align': imgblock.align
  }"
>
  @if (imgblock.title) {
    <h3
      [ngStyle]="{
        'margin-bottom:10px; display:block;': true,
        color: imgblock.color ? imgblock.color : color
      }"
    >
      {{ imgblock?.title }}
    </h3>
  }
  <img
    [src]="$safeNavigationMigration(imgblock?.imgUrl)"
    [alt]="imgblock.alt"
    [title]="
      imgblock?.imgTitle && imgblock?.imgTitle !== ''
        ? $safeNavigationMigration(imgblock?.imgTitle)
        : ''
    "
    [ngStyle]="getMyStyles()"
    [ngClass]="{
      pointer:
        imgblock?.targetUrl && imgblock?.targetUrl !== '' && imgblock?.targetUrl !== 'https://'
    }"
    (click)="openImageUrl($safeNavigationMigration(imgblock?.targetUrl))"
    (keyup.enter)="openImageUrl($safeNavigationMigration(imgblock?.targetUrl))"
    [tabindex]="imgblock?.targetUrl ? 0 : -1"
  />
</div>
